<template>
  <!-- 司机管理 -->
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
     <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="90px" size="mini">
       <div class="">
         <el-form-item label="账号:" prop="accountNum">
           <el-input  placeholder="" maxlength="30" v-model="searchFrom.accountNum"></el-input>
         </el-form-item>
         <el-form-item label="状态:" prop="stateFlg">
           <el-select v-model="searchFrom.stateFlg" placeholder="请选择">
             <el-option
               v-for="item in options"
               :key="item.value"
               :label="item.label"
               :value="item.value">
             </el-option>
           </el-select>
         </el-form-item>
       </div>
       <div class="searchBtnBox">
         <el-form-item btnCode="00AP002B001"  v-if="btnFlg[0]" >
           <el-button type="primary"  @click="addRegion">新增</el-button>
         </el-form-item>
        <!-- <el-form-item>
           <el-button type="danger"   @click="delDeiver">删除</el-button>
         </el-form-item>-->
         <el-form-item btnCode="00AP002B002"  v-if="btnFlg[1]">
           <el-button type="primary" @click="searchFn">查询</el-button>
         </el-form-item>
         <el-form-item btnCode="00AP002B003"  v-if="btnFlg[2]">
           <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
         </el-form-item>
         &nbsp;
       </div>
     </el-form>

   </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
       <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick" height="100%" style="width: 100%" center>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作">
            <template slot-scope="scope">
              <div>
              <el-button type="text" size="mini" @click="suspension(scope.row)" btnCode="00AP002B004" v-if="scope.row.stateFlg=='1'&&btnFlg[3]">启用</el-button>
              <el-button type="text" size="mini" @click="suspension(scope.row)" btnCode="00AP002B005" v-if="scope.row.stateFlg=='0'&&btnFlg[4]">停用</el-button>
<!--
              <el-button type="text" size="mini" @click="modifyRegion(scope.row)">编辑</el-button>
-->

              <el-button type="text" size="mini" @click="deleteParam(scope.row)" btnCode="00AP002B006" v-if="scope.row.stateFlg=='1'&&btnFlg[5]">删除</el-button>
              <!--<el-button type="text" size="mini" @click="seeAppSecretFrame(scope.row)">查看秘钥</el-button>-->
            </div>
            </template>
        </el-table-column>
        <el-table-column prop="tenantName" label="租户名称"></el-table-column>
        <el-table-column prop="accountNum" label="账号"></el-table-column>
         <el-table-column prop="appId" label="AppID"></el-table-column>
         <el-table-column prop="createUserName" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="160" :formatter="dateFormat"  label="创建时间"></el-table-column>
         <el-table-column prop="stateFlg" label="状态"  align="center">
           <template slot-scope="scope">
             <div>
              <span v-if="scope.row.stateFlg=='1'">
                停用
              </span>
             <span v-else-if="scope.row.stateFlg=='0'">
                启用
              </span>
              </div>
           </template>
         </el-table-column>
       </el-table>
    </div>
   <!-- 分页 -->
   <div>
     <el-pagination background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchFrom.pageNo"
                    :page-sizes="[25,50,100]"
                    :page-size="searchFrom.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
     </el-pagination>
   </div>
    <!-- 新建修改 -->
    <el-dialog  :title="title"  :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="inpBox">
               <el-form-item label="账号:" prop="accountNum">
                <el-input  placeholder="" maxlength="32" v-model.trim="addFrom.accountNum"></el-input>
              </el-form-item>
              <el-form-item label="AppID:" prop="appId">
                <el-input  placeholder="" maxlength="64" v-model.trim="addFrom.appId"></el-input>
              </el-form-item>
              <el-form-item label="AppSecret:" prop="appSecret">
                <el-input  placeholder="" maxlength="64" v-model.trim="addFrom.appSecret"></el-input>
              </el-form-item>

        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
   <!-- 查看秘钥-->
   <el-dialog  :title="title"  :visible.sync="dialogAppSecret" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" center>
      <span>
         <el-form :inline="true" :rules="rules2" :model="addFrom2" ref="addFrom2" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="inpBox">

            <el-form-item label="输入密码:" prop="password">
                <el-input type="password"  placeholder="" maxlength="32" v-model.trim="addFrom2.password" ref="password"></el-input>
            </el-form-item>
            <el-form-item label="" prop="id" style="display: none;">
                <el-input  placeholder="" maxlength="32" v-model.trim="addFrom2.id" ref="id"></el-input>
            </el-form-item>
        </div>
        </el-form>
      </span>
     <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAppSecret = false">取 消</el-button>
        <el-button type="primary" @click="seeAppSecret()">确 定</el-button>
      </span>
   </el-dialog>

 </div>
</template>

<script>
import { encryption } from '@/utils/util'
import { getBtn } from '@/utils/getButton'
import { aParAdd, aParlist, aParupdate, aParmDelete, aParmDel, aParcheckPwd, aParlistToken } from '@/api/video'

export default {
  data () {
    return {
      h: '500px',
      title: '新建',
      dialogVisible: false,
      dialogAppSecret: false,
      checkList: [],
      tableList: [],
      loading: 'false',
      ids: [],
      rules: {
        accountNum: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        appId: [
          { required: true, message: '请输入appId', trigger: 'blur' }
        ],
        appSecret: [
          { required: true, message: '请输入appSecret', trigger: 'blur' }
        ]
      },
      addFrom2: {
        password: '',
        id: ''
      },
      rules2: {
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      addFrom: {
        accountNum: ' ',
        appId: '',
        appSecret: ''
      },
      searchFrom: {
        pageNo: 1,
        pageSize: 25
      },
      total: 0,
      options: [
        {
          value: '0',
          label: '启用'
        },
        {
          value: '1',
          label: '停用'
        }],
      btnFlg: [],
      btnIdArr: ['00AP002B001', '00AP002B002', '00AP002B003',
        '00AP002B004', '00AP002B005', '00AP002B006']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/parameter')
    this.getList(this.searchFrom)
    // this.testApi();
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 162) + 'px'
  },
  methods: {
    testApi () {
      aParlistToken({ deviceNumber: '5M0059DPAZ0E290', channelId: '0' }).then(res => {
        // alert(res)
      })
    },

    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      aParlist(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 重置
    resetForm (formName) {
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 25,
        createTime: null
      }
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.title = '新建'
      this.addFrom = {}
      this.dialogVisible = true
      this.isAdd = true
    },
    // 修改
    modifyRegion (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            aParAdd(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            aParupdate(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 停用/启用
    suspension (row) {
      this.$confirm('是否执行此操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        aParmDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 删除
    deleteParam (row) {
      const selectData = this.$refs.table.selection
      if (row.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        /* this.id = []
        selectData.some(item => {
          this.ids.push(item.id)
        }) */
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          aParmDel({ id: row.id }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },
    // 查看秘钥
    seeAppSecretFrame (row) {
      this.title = '查看秘钥'
      this.addFrom2 = {}
      this.addFrom2.id = row.id
      this.dialogAppSecret = true
    },
    // 查看秘钥
    seeAppSecret (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      let data = encryption({
        data: this.addFrom2,
        key: this.global.key,
        param: ['password']
      })
      aParcheckPwd(
        {
          password: data.password,
          id: this.addFrom2.id
        }
      ).then(res => {
        if (res == false) {
          this.$alert('密码有误', '查看秘钥')
        } else {
          this.$alert(res.appSecret, '查看秘钥')
          this.dialogAppSecret = false
        }
        loading.close()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    closeDialog () {
      if (this.$refs.addFrom !== undefined) {
        this.$refs.addFrom.resetFields()
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>
<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
</style>
